import { useMutation, useQueryClient } from '@tanstack/react-query';

import { showErrorDialog } from '@/shared/utils/show-error-dialog';
import { deleteQuery } from '../api';

export function useDeleteQuery() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteQuery,
    onSuccess: (_, variables) => {
      // Invalidate saved queries list to reflect the deletion
      queryClient.invalidateQueries({
        queryKey: ['saved-queries', variables.workspaceId],
      });
    },
    onError: (error) => {
      showErrorDialog({
        error,
        title: 'Failed to delete query',
      });
    },
  });
}
